import { paths } from '~/__generated__/botco-api-schema';
import { ExtractPathParamsFromPath } from '~/types/open-api-helpers';

import { axiosClient } from '../axiosClient';
import { AgentForm, Intent } from './types';

type PathUrl = paths['/v2/agents/{agentId}/forms/{formId}/connections']['get'];
type Response = {
  sourceForms: AgentForm[];
  sourceIntents: Intent[];
};
type Request = ExtractPathParamsFromPath<PathUrl>;

export const getAgentFormConnections = ({ agentId, formId }: Request) => {
  return axiosClient.get<Response>(
    `/v2/agents/${agentId}/forms/${formId}/connections`
  );
};
